import { isEmpty, isNil, isString, noop } from 'lodash'
import { createStore } from 'zustand'

import { toArray, findTreeMatches } from '@eastcoal/common/utils/array'

import { DeptUserBaseStore } from './interface'

export const createDeptUserBaseStore = <M>() =>
  createStore<DeptUserBaseStore<M>>((set, get) => ({
    data: [],
    error: undefined,
    loading: false,
    reload: noop,
    multiple: undefined,
    value: undefined,
    setValue: value => {
      const checkedKeys = isEmpty(value)
        ? []
        : toArray(value)
            ?.filter(item => isString(item) || !isNil(item.id))
            ?.map(item => (isString(item) ? item : `${item.id}`))
      set({
        value,
        selectedKeys: checkedKeys
      })
    },
    triggerChangeWhenSelect: true,
    onChange: undefined,
    selectedKeys: [],
    setSelectedKeys: (keys: string[]) => {
      const { data, multiple, triggerChangeWhenSelect, onChange } = get()
      const checkedKeys = multiple ? keys : keys.slice(-1)
      const values = findTreeMatches(
        data,
        checkedKeys,
        (item, key) => item.id === key
      )
      const value: any = multiple ? values : values[0]
      if (triggerChangeWhenSelect) onChange?.(value)
      set({
        value,
        selectedKeys: checkedKeys
      })
    },
    reset() {
      get().setValue(get().value)
    }
  }))
